import * as T from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import { material } from './characters.js';

export const V=new T.Vector3(),Q=new T.Object3D();
export const circle=new T.RingGeometry(.65,.72,40),shotGeometry=new T.IcosahedronGeometry(1,1),giftGeometry=new RoundedBoxGeometry(1,1,1,2,.12);
export const bowGeometry=new T.TorusGeometry(.17,.045,6,12);
export const sphereGeometry=new T.SphereGeometry(1,24,16);
export const colorFor=kind=>({hearth:'#65f1b5',roots:'#79d994',electric:'#f88bff',blizzard:'#88dfff',fire:'#ff8b58',rain:'#ffbc73',mine:'#e298ff'}[kind]||'#96f1ff');
export function addMesh(group,geo,color,x,y,z,sx=1,sy=sx,sz=sx,metal=0,glow=0){const m=new T.Mesh(geo,material(color,metal,glow));m.position.set(x,y,z);m.scale.set(sx,sy,sz);m.castShadow=true;m.receiveShadow=true;group.add(m);return m;}
export function box(g,c,x,y,z,w,h,d,metal=0){return addMesh(g,giftGeometry,c,x,y,z,w,h,d,metal);}
export function gift(g,x,y,z,s=.6,color='#cf526f'){
  const a=new T.Group();a.position.set(x,y,z);a.scale.setScalar(s);g.add(a);
  box(a,color,0,.5,0,1,1,1);box(a,'#ffdf90',0,.51,0,1.035,1.035,.13,.3);box(a,'#ffdf90',0,.51,0,.13,1.035,1.04,.3);
  for(const sign of [-1,1]){const bow=addMesh(a,bowGeometry,'#ffdf90',sign*.14,1.09,0);bow.rotation.z=-sign*.45;bow.scale.y=.65;}
  return a;
}
export function pine(g,x,z,scale=1){
  const a=new T.Group();a.position.set(x,0,z);a.scale.setScalar(scale);g.add(a);
  addMesh(a,new T.CylinderGeometry(.16,.23,1,7),'#74665e',0,.45,0);
  for(let i=0;i<3;i++){
    const r=1.3-i*.28,y=1.35+i*.65;
    addMesh(a,new T.ConeGeometry(r,1.5,9),['#245d62','#317374','#488c8b'][i],0,y,0);
    addMesh(a,new T.ConeGeometry(r*.58,.90,9),'#d7f1f3',0,y+.33,0);
  }
}
export function mergeStatic(group){
  group.updateMatrixWorld(true);const inv=group.matrixWorld.clone().invert(),parts=new Map();
  group.traverse(o=>{if(o.isMesh){const id=o.material.uuid;if(!parts.has(id))parts.set(id,{mat:o.material,list:[]});parts.get(id).list.push((o.geometry.index?o.geometry.toNonIndexed():o.geometry.clone()).applyMatrix4(inv.clone().multiply(o.matrixWorld)));}});
  group.clear();for(const {mat,list} of parts.values()){const geo=mergeGeometries(list);list.forEach(g=>g.dispose());if(!geo)continue;const m=new T.Mesh(geo,mat);m.castShadow=true;m.receiveShadow=true;group.add(m);}
}

